import { type FC } from 'react'

import { useTranslation } from 'react-i18next'
import TextareaAutosize from 'react-textarea-autosize'
import './_addPoll.scss'

interface Props {
    question: string
    handleQuestionChange: (value: string) => void
    validationError?: string
}

const POLL_QUESTION_MAX_LENGTH = 50
const POLL_ALLOWED_CHARACTERS_REGEX = /^[A-Za-z0-9 ?!,.:;)]*$/

const YesNoQuestion: FC<Props> = ({
    question,
    handleQuestionChange,
    validationError
}) => {
    const { t } = useTranslation()

    const handleQuestionInputChange = (value: string) => {
        if (POLL_ALLOWED_CHARACTERS_REGEX.test(value)) {
            handleQuestionChange(value)
        }
    }

    return (
        <div className='yesNoQuestion'>
            <div className='yesNoQuestion__input'>
                <TextareaAutosize
                    name='question'
                    id='question'
                    placeholder={`${t('askAQuestion')}...`}
                    maxLength={POLL_QUESTION_MAX_LENGTH}
                    value={question}
                    minRows={1}
                    maxRows={2}
                    onChange={e => {
                        handleQuestionInputChange(e.target.value)
                    }}
                    autoComplete='off'
                />

                <div className='yesNoQuestion__input__error'>
                    {validationError}
                </div>
            </div>

            <div className='yesNoQuestion__buttons'>
                <div className='yesNoQuestion__button yesNoQuestion__button--yes'>
                    {t('yes')}
                </div>
                <div className='yesNoQuestion__button yesNoQuestion__button--no'>
                    {t('no')}
                </div>
            </div>
        </div>
    )
}

export default YesNoQuestion